export default __webpack_public_path__ + "static/media/pok.ce4807f8.png";